// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tMpU7","header":"styles_header__NE5Ep","overlay":"styles_overlay__Ea4aM","title":"styles_title__okJWd"};